<template>
  <transition name="slide-fade">
    <div fluid>
      <v-layout wrap class="pa-1">
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <v-spacer></v-spacer>
              Request Service
              <v-spacer></v-spacer>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout wrap class="align-center">
        <v-flex xs12 md6 sm6 class="pa-1">
          <v-card>
            <v-card-title class="py-0">
              <v-spacer></v-spacer>
              <v-btn x-small icon fab text title="Help menu" @click="help = !help" color="orange">
                <v-icon>{{ icons.help }}</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <div v-if="!$page.props.user">
                <p class="text-center">To Request Service</p>
                <div class="layout justify-space-around">
                  <v-btn small href="/service_request/create" @click.prevent.stop="goTo('/service_request/create', { replace: true })">Login</v-btn>
                  <span>OR</span>
                  <v-btn small href="/client/register" @click.stop.prevent="goTo('/client/register')" title="Register as a patient">Register as a Patient</v-btn>
                </div>
              </div>
              <form @submit.prevent="saveRequest" v-else novalidate>
                <v-radio-group v-model="service.type" row>
                  <v-radio label="Cash" value="cash"></v-radio>
                  <v-radio label="Insurance" value="insurance"></v-radio>
                </v-radio-group>
                <v-select :items="insurance_providers" v-model="service.insurance_provider_id" item-value="id" item-text="name" label="Insurance Provider" prepend-inner-icon="mdi-umbrella" v-if="service.type === 'insurance'">
                  <template #no-data>
                    <v-card flat>
                      <v-card-title class="py-0">
                        <v-spacer></v-spacer>&#128549;
                      </v-card-title>
                      <v-card-text class="red--text font-weight-bold">
                        We don't support insurance payments for now.<br>
                        Check back later or <a @click="service.type = 'cash'">use cash</a>.
                      </v-card-text>
                    </v-card>
                  </template>
                </v-select>
                <v-select label="Select Package" dense prepend-inner-icon="mdi-package-variant" clearable v-model.number="service.package_id" :items="packages" item-value="id" item-text="name" required v-if="service.type === 'insurance' ? service.insurance_provider_id : true">
                  <template v-slot:item="{ active, item, attrs, on }" :temp="active">
                    <v-list-item v-on="on" v-bind="attrs" #default="{ active }" three-line>
                      <v-list-item-action>
                      <v-checkbox :input-value="active"></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-row no-gutters align="center">
                          <span>{{ item.name }}</span>
                          <v-spacer></v-spacer>
                          <v-chip text-color="white" :color="item.color" small v-if="service.type === 'cash'"
                          >{{ item.currency }} {{ item.cost }}</v-chip>
                          </v-row>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <span>{{ item.description }}</span>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          <span v-if="service.type === 'cash'"> {{ item.currency }} {{ item.cost }}</span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
                <div v-if="$breakpoint.xsOnly" class="mb-5">
                  <geolocation-component @coordinates="updateLocation" v-if="service.package_id"></geolocation-component>
                </div>
                <v-text-field label="Phone Number" dense v-model="service.phone" inputmode="numeric" required placeholder="Please enter your phone number" hint="The healthcare professional will call you on this number" prepend-inner-icon="mdi-cellphone-basic" v-if="service.package_id"></v-text-field><br>
                <p @click.stop.prevent="informC = true" v-if="famPackage || tikoPackage">
                  <v-icon v-if="!informC" color="blue">
                    {{ service.informed_choice ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                  </v-icon>
                  <v-icon v-else color="blue">mdi-checkbox-intermediate</v-icon>
                  I have read and understood my &nbsp;<a @click="informC = !informC" title="Informed Choice">Informed Choice</a>
                </p>
                <p @click.stop.prevent="meligibility = true" v-if="famPackage || tikoPackage">
                  <v-icon v-if="!meligibility" color="blue">
                    {{ service.details ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                  </v-icon>
                  <v-icon v-else color="blue">mdi-checkbox-intermediate</v-icon>
                  I have answered to my &nbsp;<a @click="meligibility = !meligibility" title="Medical Eligibility">Medical Eligibility</a>
                </p>
                <v-textarea :rows="3" auto-grow dense v-model="service.note" placeholder="Give a brief description of your current illness, or list of drugs(medicine), or, laboratory tests"  label="Notes" required counter="250" clearable clear-icon="mdi-delete" :rules="rules"></v-textarea>
                <v-text-field label="Mpesa Number" prefix="+254" v-model="service.mpesa" max="999999999" :error="!service.mpesa || service.mpesa.length != 9" :success="service.mpesa && service.mpesa.length === 9" type="number" v-if="service.type == 'cash' && amountDue > 0" class="hidden">
                  <span slot="prepend">
                    <img src="/images/mpesa.svg" height="16px" alt="Mpesa Logo">
                  </span>
                </v-text-field>
                <p class="mb-0" v-if="service.package_id">Amount to pay: {{ currency }} {{ amountDue.format() }}</p>
                <input type="file" ref="docs" style="visibility: hidden; position: absolute;" accept=".jpg,.jpeg,.png,.pdf" @change="fileSelected">
                <v-btn small class="primary" v-if="docsPreview" title="Remove file" @click="docsPreview = null">{{ 'Remove File' }}</v-btn>
                <v-btn small text @click.stop="$refs.docs.click()" title="Upload Prescription / Lab request" v-if="adminPackage && !docsPreview">Upload Prescription / Lab Request</v-btn><br>
                <v-text-field label="Coupon" v-model="service.coupon" hint="Discount to be awarded if coupon is valid" v-if="service.package_id" clearable maxLength="12" :counter="12">
                  <template v-slot:append="">
                    <v-btn small outlined @click="checkValidity" title="Check Validity of coupon" v-if="service.coupon" :loading="checkingValidity">Check</v-btn>
                  </template>
                </v-text-field>
                <v-btn small type="submit" class="primary pull-right" :disabled="disabled" :loading="service.processing" title="Next">
                  Next
                  <v-icon right>mdi-chevron-double-right</v-icon>
                </v-btn><br>
              </form>
            </v-card-text>
            <v-card-actions>
              <img src="/images/PayPal.svg" alt="PayPal logo" height="32px" contain>
              <v-spacer></v-spacer>
              <a href="tel:+254706749033" class="phone-number">0706749033</a>
              <v-spacer></v-spacer>
              <img src="/images/mpesa.svg" alt="MPESA logo" height="32px" contain>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 sm6 class="pa-1 pb-0">
          <div v-if="!$breakpoint.xsOnly">
            <v-card v-if="service.package_id">
              <geolocation-component @coordinates="updateLocation"></geolocation-component>
            </v-card>
          </div>
          <v-card flat class="" v-if="!service.package_id">
            <v-card-text class="black--text pa-0">
              <v-img lazy-src="/images/youtube-home-health.gif" src="/images/youtube-home-health.png" max-height="300" @click="viewYoutube = true" v-show="!viewYoutube" contain alt="YouTube player" title="Click to show youtube player"></v-img>
              <youtube-component v-if="viewYoutube" :src="'https://www.youtube.com/embed/R0N2PEKQS98?autoplay=1'"></youtube-component>
              <!-- <v-responsive :aspect-ratio="16/9"> -->
              <!-- <iframe width="100%" height="300" ref="youtube-iframe" data-src="https://www.youtube.com/embed/R0N2PEKQS98" title="YouTube video player" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->
                <!-- <iframe width="100%" height="300" title="Youtube introductory video" src="https://www.youtube.com/embed/R0N2PEKQS98" v-if="mounted"></iframe> -->
              <!-- </v-responsive> -->
              <!-- <v-img lazy-src="/images/placeholder.gif" src="/images/intro.jpg"></v-img> -->
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <mk-dialog v-model="informC" :reload="false" :theme="$breakpoint.smAndUp">
        <template #title>Informed Choice (read to the end)</template>
        <v-card>
          <v-card-text>
            <informed-choice-fp></informed-choice-fp>
          </v-card-text>
          <v-card-actions class="py-1">
            <v-checkbox v-model="service.informed_choice" @click="informC = false">
              <template #label>
                I have read and understood this informed choice!
              </template>
            </v-checkbox>
            <v-spacer></v-spacer>
            <a target="_blank" href="/informed-choice">Read more here</a>
          </v-card-actions>
        </v-card>
      </mk-dialog>
      <mk-dialog v-model="help" :reload="false">
        <template #title>Placing a Request</template>
        <placing-request-help></placing-request-help>
      </mk-dialog>
      <mk-dialog v-model="meligibility" :reload="false" :theme="true" persistent>
        <template #title>Medical Eligibility</template>
        <medicalEligibility @eligibility="addEligibility"></medicalEligibility>
      </mk-dialog>
    </div>
  </transition>
</template>

<script>
  import helpMixin from /* webpackMode: 'lazy' */ /* webpackChunkName: "main" */ '@/Mixins/helpComponent'
  const MedicalEligibility = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "service-requests" */ '@/Components/ServiceRequest/components/medicalEligibility')
  const MkDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/mk-dialog')
  const InformedChoiceFp = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/Pages/informedchoice')
  const GeolocationComponent =  async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "geolocation" */ '@/Components/components/geolocation')
  const YoutubeComponent =  async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "youtube-component" */ '@/Components/components/youtube')

  export default {
    name: 'CreateServiceRequest',
    //layout,
    props: [
      'packages',
      'insurance_providers',
      'coupon'
    ],
    mixins: [
      helpMixin
    ],
    components: {
      MedicalEligibility,
      MkDialog,
      InformedChoiceFp,
      GeolocationComponent,
      YoutubeComponent,
    },
    data () {
      return {
        service: this.$inertia.form({
          '_method': 'POST',
          package_id: '',
          note: '',
          phone: '+254',
          longitude: this.mylng,
          latitude: this.mylat,
          file: null,
          type: '',
          insurance_provider_id: '',
          informed_choice: false,
          mpesa: '',
          details: null,
          coupon: this.coupon,
        }),
        locationWatcher: '',
        mycoordinates: {
          lat: 0.49,
          lng: 37.62
        },
        zoom: 6,
        place: {},
        filesize: 2097152,
        filetypes: ['pdf', 'jpeg', 'jpg', 'png'],
        docsPreview: null,
        rules: [v => v.length <= 250 || 'Max 250 characters'],
        informC: false,
        help: false,
        meligibility: false,
        checkingValidity: false,
        mounted: false,
        viewYoutube: false,
      }
    },
    methods: {
      saveRequest () {
        this.service.longitude = this.mylng ? this.mylng : this.mycoordinates.lng
        this.service.latitude = this.mylat ? this.mylat : this.mycoordinates.lat
        console.warn(this.service);
        if (this.docsPreview) {
          this.service.file = this.$refs.docs.files[0]
        }
        this.service.post('/service_requests', {
          preserveScroll: true,
          onSuccess: () => {
            this.loading = false
          }
        })
      },
      getCordinates () {
        var options = {
          enableHighAccuracy: true, //defaults to false
          timeout: Infinity, //defaults to Infinity
          maximumAge: 0 //defaults to 0
        }
        this.locationWatcher = this.$watchLocation(options)
        .then(coordinates => {
          this.mycoordinates = coordinates
          this.zoom = 14
        })
        .catch(error => {
          swal(error, 'Location access is needed for this page to work', 'error')
        })
      },
      newloc (e) {
        // console.log(e)
        this.mycoordinates.lat = e.latLng.lat()
        this.mycoordinates.lng = e.latLng.lng()
      },
      getloc (e) {
        // console.log(e)
        this.mycoordinates.lat = e.latLng.lat()
        this.mycoordinates.lng = e.latLng.lng()
      },
      setPlace(place) {
        this.place = place
      },
      usePlace(place) {
        if (this.place) {
          this.mycoordinates.lat = this.place.geometry.location.lat()
          this.mycoordinates.lng = this.place.geometry.location.lng()
          // this.markers.push({
          //   position: {
          //     lat: this.place.geometry.location.lat(),
          //     lng: this.place.geometry.location.lng(),
          //   }
          // })
          this.place = null;
        }
      },
      fileSelected () {
        var size = this.$refs.docs.files[0].size
        var extension = this.$refs.docs.files[0].name.split('.').pop().toLowerCase()

        if (!this.validateFile(size, extension)) {
          this.$refs.docs.value = null
          swal('Error', 'Choose<br>a file less than 2MB<br>a pdf or image file of extension jpg or png', 'error')
          return
        }
        const reader = new FileReader()

        reader.onload = (e) => {
          this.docsPreview = e.target.result;
        };

        reader.readAsDataURL(this.$refs.docs.files[0]);
      },
      validateFile (size, type) {
        return this.validateFileSize(size) && this.validateFileType(type)
      },
      validateFileSize (size) {
        return size < this.filesize
      },
      validateFileType (type) {
        var types = this.filetypes
        var index = types.indexOf(type)
        return index != -1
      },
      addEligibility (event) {
        this.service.details = { medical_eligibility: event.eligibility }
        this.meligibility = false
      },
      checkValidity () {
        this.checkingValidity = true;
        this.$inertia.post('/coupons/validity', { code: this.service.coupon }, {
          onSuccess: (data) => {
            // console.log('data', data);
          },
          onFinish: () => {
            this.checkingValidity = false;
          },
          preserveScroll: true,
          preserveState: true,
        })
      },
      updateLocation (e) {
        // console.log(e, this.mycoordinates, 'updateLocation')
        this.mycoordinates.lat = e.lat
        this.mycoordinates.lng = e.lng
        // console.log(this.mycoordinates)
      }
    },
    beforeDestroy () {
      // this.$clearLocationWatch(this.locationWatcher)
    },
    computed: {
      markers () {
        if (!this.mycoordinates.lat || !this.mycoordinates.lng) {
          return []
        }
        return [
          {
            position: {
              lat: this.mycoordinates.lat,
              lng: this.mycoordinates.lng
            }
          }
        ]
      },
      mylat () {
        return this.mycoordinates ? this.mycoordinates.lat : 0.00
      },
      mylng () {
        return this.mycoordinates ? this.mycoordinates.lng : 0.00
      },
      client () {
        return this.$user ? this.$user.client : null
      },
      selectedPackage () {
        let packageselected = this.packages.filter((pack) => {
          return pack.id === this.service.package_id
        })
        return packageselected[0]
      },
      adminPackage () {
        if (!this.selectedPackage || !this.selectedPackage.id) {
          return false
        }
        if (this.selectedPackage.admin) {
          return true
        }
        return false
      },
      tikoPackage () {
        if (!this.selectedPackage || !this.selectedPackage.id) {
          return false
        }
        if (this.selectedPackage.map_to === 'tiko') {
          return true
        }
        return false
      },
      famPackage () {
        if (!this.selectedPackage || !this.selectedPackage.id) {
          return false
        }
        if (this.selectedPackage.map_to === 'family_planning') {
          return true
        }
        return false
      },
      amountDue () {
        if (!this.selectedPackage) {
          return 0
        } else {
          return this.selectedPackage.cost || 0
        }
      },
      currency () {
        if (!this.selectedPackage) {
          return;
        } else {
          return this.selectedPackage.currency
        }
      },
      disabled () {
        if (!this.client || !this.service.package_id) {
          return true
        }
        if (this.famPackage || this.tikoPackage) {
          if (!this.service.details || !this.service.informed_choice) {
            return true;
          }
        }
        if (!this.service.note) {
          return true;
        }
        return false
      }
    },
    watch: {
      'service.package_id': function (value) {
        if (!this.client) {
          this.service.package_id = ''
          swal({
            title: 'Alert!',
            text: 'We need additional details',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'red',
            confirmButtonText:'Enter Details',
          },
          function () {
            this.goTo('/user/client?create=true')
          }.bind(this))
        }
        this.service.phone = this.client?.phone
        this.service.mpesa = this.client?.phone
        // this.getCordinates()
      },
      'docsPreview': function (value) {
        if (!value) {
          this.$refs.docs.value = null
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.mounted = true
      })
    }
  }
</script>

<style scoped>
  label > input {
    border-bottom: 1px solid grey;
    padding: 5px;
  }
  .my-floating-label {
    position: absolute;
    z-index: 1;
    background-color: rgba(200,200,200,0.9);
    color: black;
    padding: 11px;
    border-radius: 0 0 30px;
  }
  .phone-number {
    font-style: italic;
    font-family: monospace;
    font-size: x-large;
  }
</style>
